export enum DynamicQueryOperator {
	Between = 'between',
	BetweenWithNull = 'betweenn',
	BitwiseOr = 'bor',
	BitwiseOrWithNull = 'born',
	Equals = 'eq',
	GreaterThan = 'gt',
	GreaterThanOrEqualTo = 'gte',
	In = 'in',
	Inn = 'inn',
	IsNull = 'isnull',
	LessThan = 'lt',
	LessThanOrEqualTo = 'lte',
	Like = 'like',
	NotEqual = 'ne',
	NotIn = 'notin',
	NotLike = 'notlike',
	NotNull = 'notnull'
}
